import React, {useState} from "react";
import {useForm} from "react-hook-form";
import SliderFields from "./SliderFields";
import axios from "axios";

export default function () {
  const {register, handleSubmit, reset, control, watch, setValue, getValues} = useForm({
    defaultValues: {only_discounted: false}
  });
  const [errors, setErrors] = useState({});
  const [data, setData] = useState({});

  const sliderFields = <SliderFields {...{register, errors, control, watch, setValue, data, setData, getValues}} />;

  return {
    setErrors,
    sliderFields,
    handleSubmit,
    data,
    setData,
    reset,
  }
}